/**
 * type for a document info, used for passing details about the loaded document around
 */
import { HierarchyDocumentInfo } from './hierarchy-document-Info.type';
export interface DocumentInfo {
  documentListId?: string;
  templateId?: string;
  documentId?: string;
  overrideTemplateId?: string;
  showFormAfterCreated?: boolean;
  isNew?: boolean;
  name?: string;
  isMainDoc?: boolean;
  altTemplateId?: string;
  hierarchyInfo?: HierarchyDocumentInfo,
  options?: any;
}
